import { Action, SidebarState } from "./types";

export const CHANGE_SIDEBAR_WIDTH = "CHANGE_SIDEBAR_WIDTH";

export default function view(state: SidebarState = { sidebar: "max" }, action: Action): SidebarState {
  switch (action.type) {
    case CHANGE_SIDEBAR_WIDTH:
      return action.payload;

    default:
      return state;
  }
}
